import { MainMobileHeaderItem, SecondaryMobileHeaderItem, MenuSettings, ScrollMobileHeaderItem } from "./categoryHeaderMutamWrapper";
import { categoryObj } from "../../../../ynet1280/videoGalleryVerticalWidget/components/videoGalleryVerticalMutamComponenta";
import { CategoryHeaderMutamSideMenu } from "./categoryHeaderMutamSideMenu";
import { useState } from "react"
import { CategoryScrollHeaderMutam } from "./categoryScrollHeaderMutam";

interface CategoryHeaderMutamProps {
    mainItems: MainMobileHeaderItem[]
    secondaryItems: SecondaryMobileHeaderItem[]
    scrollItems: ScrollMobileHeaderItem[]
    category: categoryObj
    menuSettings: MenuSettings
    isArticlePage: boolean
    domain: string
}

export const CategoryHeaderMutam = (props: CategoryHeaderMutamProps) => {

    const { mainItems, secondaryItems, scrollItems, category, menuSettings, isArticlePage, domain } = props
    const [showSideMenu, setShowSideMenu] = useState<boolean>(false)
    let selectedId = category ? category.id : "";
    const selectedCategory = mainItems.find(item => item.categoryId === selectedId) || secondaryItems.find(item => item.categoryId === selectedId)
    const overflow = showSideMenu ? "hidden" : "scroll";
    const bodyStyle = `body {overflow: ${overflow} !important;}`

    const onSideMenuBtnClick = () => {
        setShowSideMenu(!showSideMenu)
    }

    return (
        <div className="category-header-mutam" style={{ backgroundColor: selectedCategory && selectedCategory.bgColor ? selectedCategory.bgColor : "#d01e25" }}>
            <style>
                {bodyStyle}
            </style>

            <CategoryHeaderMutamSideMenu
                domain={domain}
                mainItems={mainItems}
                showSideMenu={showSideMenu}
                menuSettings={menuSettings}
                secondaryItems={secondaryItems}
                oncloseMenu={onSideMenuBtnClick}
            />

            <div className="heder-title">
                {isArticlePage ? category.name : (selectedCategory && selectedCategory.categoryId !== "8" && selectedCategory.title ?
                    selectedCategory.title
                    :
                    <div className="calcalist-main-logo icon"></div>)
                }
            </div>

            <CategoryScrollHeaderMutam scrollItems={scrollItems} openHam={onSideMenuBtnClick} />
        </div>
    )
}

CategoryHeaderMutam.siteScriptName = 'CategoryHeaderMutam'
